<template>
<div>
  <div class="overlay" :disabled="!ifTeamleaderAnchorPermission">
    <!-- <div class="top-text">
      <div class="wip-text">Work In Progress!</div>
    </div> -->
    <div class="employee">
    <tl-header type="h3" class="title">
            Quick Links
    </tl-header>
    <div class="link-text" @click="goToAddJoinees">
       Add New Joinees
    </div>
    <div class="link-text" @click="goToExitEmployees">
       Add Exiting Employees
    </div>
    <div class="link-text" @click="goToLop">
       Update LOPs/RLOPs
    </div>
    <div class="link-text" @click="goToTdsOverride">
       TDS Overrides
    </div>
    <div class="link-text" @click="goToEarnings">
      Earnings & Deductions
    </div>
  </div>
</div>
</div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
    name: "EmployeePayroll",
    data() {
        return {
            month: null,
            months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            employeeJoins: 0,
            employeeExits: 0,
            payrollDashboardsValue: false,
            role: ""
        }
    },
    computed: {
      ...mapGetters({
        getleid: "onboard/legal_entities/legal_entity_ID"
      }),
      le_id() {
        if (this.$route.params.entity_index) {
          return this.getleid(this.$route.params.entity_index);
        }
        return this.getleid(0);
      },
      ...mapState("onboard/organization", {
        orgIds: state => state.id,
      }),
      ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.payrollDashboardsValue) {
          return true;
          } else {
            return false;
          }
        } 
        // else {
        // return true 
        // }
      },
    },
    mounted() {
      this.getOrgLeIdList();
    },
    activated() {
      this.getOrgLeIdList();
    },
    methods: {
      ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
      }),

      goToAddJoinees() {
        this.$router.push(`/payroll/run/${
          this.$route.params.entity_index ? this.$route.params.entity_index : 0
          }/joinings`
        );
      },

      goToExitEmployees() {
        this.$router.push(`/payroll/run/${
          this.$route.params.entity_index ? this.$route.params.entity_index : 0
          }/exits`
        );
      },

      goToLop() {
        this.$router.push(`/payroll/run/${
          this.$route.params.entity_index ? this.$route.params.entity_index : 0
          }/lopsandrlops`
        );
      },

      goToTdsOverride() {
        this.$router.push(`/payroll/run/${
          this.$route.params.entity_index ? this.$route.params.entity_index : 0
          }/tds`
        );
      },

      goToEarnings() {
        this.$router.push(`/payroll/run/${
          this.$route.params.entity_index ? this.$route.params.entity_index : 0
          }/variableEarnings`
        );
      },

      async getOrgLeIdList() {
        const org = this.orgIds;
        const le = this.le_id;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.payrollDashboardsValue = data.data.user.permissions.payroll_dashboards ? true : false;
        //console.log("PL-3406",data);
      }
    }
}
</script>

<style lang="scss" scoped>
.title{
  padding: 20px;
}
.empDetails {
    display: flex;
    justify-content: center;

    span {
        font-size: 16px;
        color: #606060;
        margin-right: 50px;
        margin-top: 15px;
    }
}

.link-text {
  height: 18px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 600;
  color: #5d409f;
  margin: 15px 0 0 15px;
  cursor: pointer;
}
.overlay {
  position: relative;
}

.top-text {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 100%;
  z-index: 1;
}
.wip-text {
  font-family: Montserrat;
  font-size: 32px;
  font-weight: 600;
  text-align: center;
  color: #444444;
  margin-top: 30%;
  transform: rotate(-45deg);
}
.employee {
  position: relative;
}
</style>
